import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CatsNoBillCodeDescriptionEnum } from '@shared-enums/cats.enum';

import { ISelectOptions } from '../../../interfaces/internal-interfaces';

@Component({
  selector: 'app-modal-content-bill-code-change',
  templateUrl: './modal-content-bill-code-change.component.html',
  standalone: false,
})
export class ModalContentBillCodeChangeComponent implements OnInit {
  @Input() public current = '';
  @Input() public selectOptions: ISelectOptions[] = [];
  @Output() public readonly closed = new EventEmitter();

  public initial = '';

  public ngOnInit(): void {
    if (this.selectOptions.length === 0) throw Error('You must supply select options to this component.');
    this.initial = this.current;
  }

  public shouldSave(shouldSave: boolean): void {
    if (this.current === CatsNoBillCodeDescriptionEnum.Unassigned || !shouldSave) {
      this.closed.emit(null);
    } else {
      this.closed.emit(this.current);
    }
  }
}
